import { Field } from 'redux-form';
import { useTranslation } from 'react-i18next';
import DateRangeInput from '../date-range-field/DateRange';

import "react-datepicker/dist/react-datepicker.css";

// TODO: move & use shared one
const LANGUAGE_MAP = {
  kz: 'kk'
};

const DateRangeField = (props) => {
  const { i18n } = useTranslation();
  return (
    <div>
      <Field
        locale={LANGUAGE_MAP[i18n.language] || i18n.language}
        dateFormat="dd/MM/yyyy"
        label={props.label}
        id={props.id}
        name={props.name}
        typeName={props.typeName}
        order={props.order}
        values={props.options}
        required={props.required}
        component={DateRangeInput}
      />
    </div>);
}

export default DateRangeField;